"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledVerticalNavList = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VerticalNavListMixin = require("../../mixins/components/VerticalNavListMixin");
var StyledVerticalNavList = /*#__PURE__*/_styledComponents.default.ol.withConfig({
  displayName: "StyledVerticalNavList",
  componentId: "c11n-8-107-0__sc-1h79ar7-0"
})(["", ""], _VerticalNavListMixin.VerticalNavListMixin);
exports.StyledVerticalNavList = StyledVerticalNavList;